import Vue from 'vue';

import StepIdentification
  from '@/febos/chile/dnt/components/wizard/companies/60100003-2/oficialNumeration/StepIdentification';
import StepInformation
  from '@/febos/chile/dnt/components/wizard/companies/60100003-2/oficialNumeration/StepInformation';
import StepFiles
  from '@/febos/chile/dnt/components/wizard/companies/60100003-2/oficialNumeration/StepFiles';

export default () => ({
  currentStep: 0,
  steps: [
    {
      title: 'Identificación',
      component: StepIdentification
    },
    {
      title: 'Información',
      component: StepInformation
    },
    {
      title: 'Documentos relacionados',
      component: StepFiles
    }
  ],
  options: ['submitNumeration', 'draft', 'flow'],
  submitAction: 'saveDocument',
  backupAction: 'saveDocument',
  loadAllData: true,
  wizardMapper(
    {
      dnt,
      observaciones,
      destinatarios,
      adjuntos,
      referencias,
      metadata
    }
  ) {
    const data = {};
    if (dnt) {
      data.fileNumber = dnt.numero;
      data.documentType = dnt.emisorCentroCostoNumero || '';
      data.document = dnt.emisorSucursalCodigo;
      data.documentNumber = dnt.numeroInt;
      data.febosId = dnt.febosId;
      if (dnt.fechaEmision) {
        data.issueDate = Date.parse(dnt.fechaEmision);
      }
      data.deliveryDate = dnt.fechaEntrega;
      data.isPrivate = dnt.transportePuertoTipo || '0';
      data.resumen = dnt.nombreDescriptivo;
      data.institutionType = dnt.compradorCodigo;
      data.institution = dnt.emisorContactoCodigo;
      data.personName = dnt.emisorContactoNombre;
      data.personPosition = dnt.emisorContactoCargo;
      data.personEmail = dnt.emisorContactoEmail;
      data.personPhone = dnt.emisorContactoTelefono;
      data.withAttachment = parseInt(dnt.transporteViaTransporteCodigoTransporte, 10) || 0;
      data.documentDetail = dnt.transporteNotas;
      data.safiContract = dnt.transportePuertoCodigo;
      data.creatorGroup = dnt.solicitanteGrupoId;
      data.isMotherDocument = dnt.estadoCodigoEstadoComprador;
    }
    if (observaciones && observaciones.length) {
      data.observation = observaciones[0].observacion;
    }

    if (destinatarios && destinatarios.length) {
      const subjects = destinatarios
        .filter((subject) => subject.tipoDestino.toString() === '1')
        .map((subject) => {
          const subjectTypeDigitalDoc = subject.institucionCodigo
            ? {
              id: subject.institucionCodigoId,
              value: subject.institucionCodigo,
              label: subject.institucionNombre
            }
            : {};

          return {
            subjectType: {
              id: subject.destinoCodigoId,
              value: subject.destinoCodigo,
              label: subject.destinoNombre
            },
            subject: {
              id: subject.destinoListaCodigoId,
              value: subject.destinoListaCodigo,
              label: subject.destinoListaNombre
            },
            subjectEmail: subject.destinoCorreo,
            status: subject.estado,
            providence: subject.providenciaId || '',
            providenceExpiration: subject.providenciaVencimiento || '',
            dntDestinatariosId: subject.dntDestinatariosId,
            subjectTypeDigitalDoc
          };
        });

      data.subjects = [...subjects];
      data.subjectsSelected = [...subjects];

      const copies = destinatarios
        .filter((subject) => subject.tipoDestino.toString() === '2')
        .map((subject) => {
          const copySubjectTypeDigitalDoc = subject.institucionCodigo
            ? {
              id: subject.institucionCodigoId,
              value: subject.institucionCodigo,
              label: subject.institucionNombre
            }
            : {};

          return {
            copySubjectType: {
              id: subject.destinoCodigoId,
              value: subject.destinoCodigo,
              label: subject.destinoNombre
            },
            copySubject: {
              id: subject.destinoListaCodigoId,
              value: subject.destinoListaCodigo,
              label: subject.destinoListaNombre
            },
            copySubjectEmail: subject.destinoCorreo,
            providence: subject.providenciaId || '',
            providenceExpiration: subject.providenciaVencimiento || '',
            dntDestinatariosId: subject.dntDestinatariosId,
            status: subject.estado,
            copySubjectTypeDigitalDoc
          };
        });
      data.copies = [...copies];
      data.copiesSelected = [...copies];
    }

    if (adjuntos && adjuntos.length) {
      const main = adjuntos
        .find((file) => file.tipo === 'principal');
      if (main) {
        data.mainFile = {
          id: main.adjuntoId,
          mime: main.adjuntoMime,
          name: main.adjuntoNombre,
          path: main.adjuntoUrl,
          date: main.fecha,
          currentDescription: main.tipoDescripcion,
          status: main.estado || 0
        };
      }
      data.additionalFiles = adjuntos
        .filter((file) => file.tipo === 'adjunto')
        .map((file) => ({
          id: main.adjuntoId,
          mime: file.adjuntoMime,
          name: file.adjuntoNombre,
          path: file.adjuntoUrl,
          date: file.fecha,
          currentDescription: file.tipoDescripcion,
          status: file.estado || 0
        }));
    }
    if (referencias && referencias.length) {
      const relatedDocuments = referencias.map((relatedDocument) => ({
        id: relatedDocument.linea,
        type: relatedDocument.tipoDocumento,
        number: relatedDocument.folio
      }));

      data.relatedDocuments = [...relatedDocuments];
      data.relatedDocumentsSelected = [...relatedDocuments];
    }

    if (metadata) {
      metadata.forEach((field) => {
        if (field.nombre === 'title') {
          data.title = field.valor;
        }
        if (field.nombre === 'keywords') {
          data.tags = JSON.parse(field.valor);
        }
        if (field.nombre === 'acceso') {
          data.accessRights = field.valor;
        }
        if (field.nombre === 'constitute') {
          data.matter = field.valor;
        }
      });
    }

    return data;
  },
  documentMapper(input, iutCompany, nameCompany, isDraft = false, isFlow = false) {
    const data = {
      metadata: [
        { nombre: 'title', tipo: 1, valor: input.title },
        { nombre: 'acceso', tipo: 1, valor: input.accessRights },
        { nombre: 'constitute', tipo: 1, valor: input.matter }
      ],
      adjuntos: [],
      observaciones: [],
      dnt: {
        tipo: 'EXP',
        categoria: `${input.outputPrefix}`,
        emisorRut: iutCompany,
        receptorRut: iutCompany,
        emisorRazonSocial: nameCompany,
        receptorRazonSocial: nameCompany,
        claseMercadoPublico: 'numOf',
        estado: 1,
        emisorCentroCostoNumero: input.documentType,
        emisorCentroCostoNombre: input.documentTypeName,
        emisorSucursalCodigo: input.document,
        emisorSucursalDireccion: input.documentName,
        numeroInt: input.documentNumber,
        transportePuertoTipo: '0',
        fechaEntrega: input.deliveryDate,
        nombreDescriptivo: input.resumen,
        solicitanteArea: input.commissions,
        transporteViaTransporteVehiculoPatente: input.proposalStatus,
        solicitanteGrupoId: input.creatorGroup,
        solicitanteGrupoNombre: input.creatorGroupName,
        compradorCodigo: input.institutionType,
        compradorArea: input.institutionTypeName,
        estadoCodigoEstadoComprador: input.isMotherDocument,
        emisorContactoCodigo: input.institution,
        emisorContactoArea: input.institutionName,
        emisorContactoNombre: input.personName,
        emisorSucursalCiudad: input.documentOptId,
        emisorSucursalPais: input.documentTypeId,
        emisorContactoCargo: input.personPosition,
        emisorContactoEmail: input.personEmail,
        emisorContactoTelefono: input.personPhone,
        transporteViaTransporteCodigoTransporte: input.withAttachment,
        transporteNotas: input.documentDetail,
        transportePuertoCodigo: input.safiContract,
        plazo: input.adhesion
      },
      destinatarios: [
        ...(input.subjectsSelected || []).map((subject) => {
          const institution = Object.keys(subject.subjectTypeDigitalDoc).length
            ? {
              institucionCodigoId: subject.subjectTypeDigitalDoc.id,
              institucionCodigo: subject.subjectTypeDigitalDoc.value,
              institucionNombre: subject.subjectTypeDigitalDoc.label,
            }
            : {};

          return {
            tipoDestino: 1,
            estado: 1,
            destinoCodigoId: subject.subjectType.id,
            destinoCodigo: subject.subjectType.value,
            destinoNombre: subject.subjectType.label,
            destinoListaCodigoId: subject.subject.id,
            destinoListaCodigo: subject.subject.value,
            destinoListaNombre: subject.subject.label,
            destinoCorreo: subject.subjectEmail,
            providenciaId: subject.providence,
            providenciaVencimiento: subject.providenceExpiration,
            ...institution
          };
        }),
        ...(input.copiesSelected || []).map((subject) => {
          const institution = Object.keys(subject.copySubjectTypeDigitalDoc).length
            ? {
              institucionCodigoId: subject.copySubjectTypeDigitalDoc.id,
              institucionCodigo: subject.copySubjectTypeDigitalDoc.value,
              institucionNombre: subject.copySubjectTypeDigitalDoc.label,
            }
            : {};

          return {
            tipoDestino: 2,
            estado: 1,
            destinoCodigoId: subject.copySubjectType.id,
            destinoCodigo: subject.copySubjectType.value,
            destinoNombre: subject.copySubjectType.label,
            destinoListaCodigoId: subject.copySubject.id,
            destinoListaCodigo: subject.copySubject.value,
            destinoListaNombre: subject.copySubject.label,
            destinoCorreo: subject.copySubjectEmail,
            providenciaId: subject.providence,
            providenciaVencimiento: subject.providenceExpiration,
            ...institution
          };
        })
      ],
      referencias: (input.relatedDocumentsSelected || []).map((relatedDocument) => ({
        linea: relatedDocument.id,
        tipoDocumento: relatedDocument.type,
        folio: relatedDocument.number
      }))
    };

    if (input.tags) {
      data.metadata.push({ nombre: 'keywords', tipo: 2, valor: JSON.stringify(input.tags) });
    }

    if (input.issueDate) {
      data.dnt.fechaEmision = Vue.moment(input.issueDate).format('YYYY-MM-DD');
    }

    if (input.observation) {
      data.observaciones.push({
        linea: '1',
        observacion: input.observation
      });
    }

    if (input.mainFile) {
      data.adjuntos = [
        ...data.adjuntos,
        {
          tipo: 'principal',
          adjuntoMime: input.mainFile.mime,
          adjuntoNombre: input.mainFile.name,
          fecha: input.mainFile.date,
          adjuntoUrl: input.mainFile.path,
          tipoDescripcion: input.mainFile.currentDescription,
          ...(input.mainFile.id && { adjuntoId: input.mainFile.id }),
          ...(input.mainFile.status && { estado: input.mainFile.status })
        }
      ];
    }

    if (input.additionalFiles && input.additionalFiles.length) {
      data.adjuntos = [
        ...data.adjuntos,
        ...(input.additionalFiles || []).map((file) => ({
          tipo: file.interno ? 'interno' : 'adjunto',
          adjuntoMime: file.mime,
          adjuntoNombre: file.name,
          fecha: file.date,
          adjuntoUrl: file.path,
          tipoDescripcion: file.currentDescription,
          ...(file.id && { adjuntoId: file.id }),
          ...(file.status && { estado: file.status })
        }))
      ];
    }

    const draft = 3;
    if (isDraft) {
      data.dnt.estado = draft;
    }
    if (isFlow) {
      data.dnt.estado = draft;
    }

    return data;
  }
});
